import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link } from '@resy/ui-kitchen';
import { sanitizeString } from '../../../../../../../ui-kitchen/src/utils/sanitizeString';
import { handleMktAnalytics } from '../../AmexUtils';
import { CTA_EVENT_NAME } from '../../constants';
import './LayoutOffer.scss';

const LayoutOffer = (
  {
    awsFolderName,
    baseRequestUrl,
    content: {
      title,
      copy,
      copy_2: finePrint,
      image,
      cta: {
        label: ctaLabel,
        url: ctaUrl,
      } = {},
    },
    tabHeading: heading,
    Analytics,
  }
) => {
  const sanitizedHeading = sanitizeString(heading);
  const sanitizedTitle = sanitizeString(title);
  const sanitizedCopy = sanitizeString(copy);
  const sanitizedFinePrint = sanitizeString(finePrint);

  const specificParam = {
    tab_item: heading,
    action_name: `${ctaLabel} Click`,
  };
  return (
    <div
      className={cx('LayoutOffer', {
        'with-image': image,
      })}
    >
      {heading && (
      <h3
        className="LayoutOffer__heading  content-heading"
        dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
          __html: sanitizedHeading,
        }}
      />
      )}
      <div className="LayoutOffer__inner">
        <div className="LayoutOffer__content">
          {image && (
          <div className="LayoutOffer__image">
            <img src={`${baseRequestUrl}${awsFolderName}/carouselImages/tabContentImages/${image}`} alt="" />
          </div>
          )}
          <div className="LayoutOffer__copy">
            {title && (
            <h3
              className="LayoutOffer__title"
              dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                __html: sanitizedTitle,
              }}
            />
            )}
            {copy && (
            <div
              className="LayoutOffer__text"
              dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                __html: sanitizedCopy,
              }}
            />
            )}
            {finePrint && (
            <div
              className="LayoutOffer__fine-print"
              dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                __html: sanitizedFinePrint,
              }}
            />
            )}
          </div>
        </div>
        {(ctaLabel && ctaUrl)
      && (
        <Link
          href={ctaUrl}
          target="_blank"
          className="LayoutOffer__CTA"
          onClick={() => handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, specificParam)}
        >
          {ctaLabel}
        </Link>
      )}
      </div>
    </div>
  );
};

LayoutOffer.propTypes = {
  awsFolderName: PropTypes.string.isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  content: PropTypes.shape({
    title: PropTypes.string,
    copy: PropTypes.string,
    copy_2: PropTypes.string,
    image: PropTypes.string,
    cta: PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string,
      item_name: PropTypes.string,
      action_name: PropTypes.string,
    }).isRequired,
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  tabHeading: PropTypes.string,
};

LayoutOffer.defaultProps = {
  tabHeading: '',
};

export default LayoutOffer;
